import React from 'react';
import styled, { keyframes } from 'styled-components';
import footballImg from '../assets/football.png';

const bounce = keyframes`
  0%, 100% { transform: translateY(0); }
  15% { transform: translateY(-52px); }
  30% { transform: translateY(0); }
  45% { transform: translateY(-30px); }
  60% { transform: translateY(0); }
  75% { transform: translateY(-14px); }
  90% { transform: translateY(0); }
`;

const shadowPulse = keyframes`
  0%, 100% { transform: scaleX(1); opacity: 0.25; }
  15% { transform: scaleX(0.45); opacity: 0.1; }
  30% { transform: scaleX(1); opacity: 0.25; }
  45% { transform: scaleX(0.65); opacity: 0.15; }
  60% { transform: scaleX(1); opacity: 0.25; }
  75% { transform: scaleX(0.8); opacity: 0.2; }
  90% { transform: scaleX(1); opacity: 0.25; }
`;

const SpinnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  height: 100%;
  flex: 1;
  padding: 48px 0;
`;

const BallWrapper = styled.div`
  animation: ${bounce} 1.5s ease-in-out infinite;
`;

const Ball = styled.img`
  width: 56px;
  height: 56px;
`;

const Shadow = styled.div`
  width: 36px;
  height: 6px;
  margin-top: 6px;
  background: radial-gradient(ellipse, rgba(0,0,0,0.2) 0%, transparent 70%);
  border-radius: 50%;
  animation: ${shadowPulse} 1.5s ease-in-out infinite;
`;

export const LoadingSpinner: React.FC = () => {
  return (
    <SpinnerContainer>
      <BallWrapper>
        <Ball src={footballImg} alt="Loading" />
      </BallWrapper>
      <Shadow />
    </SpinnerContainer>
  );
};
